import {
  catalogApiRef,
  useStarredEntities,
} from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { GetEntitiesByRefsRequest } from '@backstage/catalog-client';
import { AcademyAlphaEntity, Kind } from '@mb.io/catalog-model';

export const useFavouriteTutorials = () => {
  const { starredEntities } = useStarredEntities();
  const catalogApi = useApi(catalogApiRef);

  const { loading, error, value } = useAsync(async () => {
    if (!starredEntities || starredEntities.size === 0) {
      return [];
    }

    const request: GetEntitiesByRefsRequest = {
      entityRefs: Array.from(starredEntities),
      filter: [{ kind: Kind.ACADEMY, 'spec.type': 'tutorial' }],
    };

    const response = await catalogApi.getEntitiesByRefs(request);
    return response.items.filter(Boolean) as AcademyAlphaEntity[];
  }, [starredEntities, catalogApi]);

  return { loading, error, value };
};
